import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Box, Divider, Grid, Typography } from "@material-ui/core";

const FormHeaderPart = (props) => {
  return (
    <Wrapper>
      <Grid item xs={12}>
        <Box pt={2}>
          <Divider />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box pt={2} pb={2} mb={2} mt={2}>
          <Typography variant={"h5"}>{props.title}</Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box pb={2} mb={2}>
          <Divider />
        </Box>
      </Grid>
    </Wrapper>
  );
};

export default FormHeaderPart;
